import React from "react";
import { Service, WeatherStationStates } from "@helpers/ui_helper";
import { farmerStatus, unauthorizedAlert } from "@helpers/unauthorizedAlert";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffect } from "react";

function AddNewStationButton({ setWeatherStationState }) {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const reg = searchParams.get("reg");
  useEffect(() => {
    if (reg) {
      searchParams.delete("reg");
      setSearchParams(searchParams);
      setWeatherStationState({
        service: Service.Weather,
        state:
          farmerStatus() === "DRAFT"
            ? WeatherStationStates.AddStationIntro
            : WeatherStationStates.MapPoint,
        stationObject: null,
      });
      unauthorizedAlert({ navigate });
    }
  }, [reg]);

  return (
    <div className="flex flex-col items-center justify-center">
      <div
        className="flex overflow-visible w-fit items-center cursor-pointer hover:brightness-105 pt-4 gap-4 text-right text-agroyar text-xl max-lg:text-[20px] font-semibold"
        onClick={() => {
          setWeatherStationState({
            service: Service.Weather,
            state:
              farmerStatus() === "DRAFT"
                ? WeatherStationStates.AddStationIntro
                : WeatherStationStates.MapPoint,
            stationObject: null,
          });
          unauthorizedAlert({ navigate });
        }}
      >
        افزودن ایستگاه جدید
        <div className="addbtn pt-2 flex items-center justify-center w-12 h-12 rounded-full card-shadow">
          +
        </div>
      </div>
    </div>
  );
}

export default AddNewStationButton;
